export enum ConsentFormElementTypeEnum {
  ShortText = 'short_text',
  Checkboxes = 'checkboxes',
  MultipleChoice = 'multiple_choice',
  Signature = 'signature',
  ReadOnly = 'read_only',
  Image = 'image',
}

export interface IConsentFormElement {
  id: string;
  type: ConsentFormElementTypeEnum;
  label: string;
  required?: boolean;
  helperText?: string;
  content?: string; // For read_only text blocks
  options?: string[]; // For checkboxes / multiple_choice
}

export interface IConsentFormAutomation {
  sendToNewUsers?: boolean;
  sendToServiceIds?: string[];
  /** Channel the form link is sent on. Absent => SMS. */
  channel?: 'sms' | 'whatsapp';
}

export interface IConsentForm {
  _id?: string;
  businessId: string;
  title: string;
  elements: IConsentFormElement[];
  active: boolean;
  automation?: IConsentFormAutomation;
  createdAt?: Date | string;
  updatedAt?: Date | string;
}

export interface IConsentFormSubmission {
  _id?: string;
  businessId: string;
  formId: string;
  formTitle: string;
  customerId?: string;
  customerName: string;
  data: Record<string, any>;
  signatureDataUrl?: string;
  pdfUrl?: string;
  submittedAt: Date | string;
}
